var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowerBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "29px",
    viewBox: "0 0 55 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lower Back") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-17",
    transform: "translate(-61.000000, -153.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Lower-Back",
    points: "66.8659666 153 110.233681 153 115.335158 182 61.6141047 182"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerBack);
export default __webpack_public_path__ + "static/media/LowerBack.00a69b9472a731698188b6643cd4f970.svg";
export { ForwardRef as ReactComponent };